"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const i18n_js_1 = __importDefault(require("i18n-js"));
const query_string_1 = __importDefault(require("query-string"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const LanguageDropdown_1 = __importDefault(require("../../../common/components/Header/LanguageDropdown"));
const Logo_1 = __importDefault(require("../../../common/components/Header/Logo"));
const KioskWrapper = styled_components_1.default.div `
  color: #fff;
  background-image: ${(props) => `url(${props.hotelView.XXL} )`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 100%;

  .logo {
    position: absolute;
    height: 10vmin;
    top: 2vmin;
  }

  .content {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .icon-circle {
    position: absolute;
    right: 4vmin;
    top: 2vmin;

    svg {
      width: 4vmin;
      height: 4vmin;
    }
  }

  h1,
  h3 {
    text-shadow: 2px 2px 2px #616362;
    padding: 0 10px;
    text-align: center;
  }

  h1 {
    font-size: 5vmin;
    margin-bottom: 0;
  }

  h3 {
    font-size: 3vmin;
    font-size: 3.8vmin;
    margin: 0.02vmin 0 4.4vmin 0;
  }

  .tiles {
    display: flex;
    justify-content: space-around;
    width: 100%;
  }

  .tile {
    background-color: ${(props) => `${props.theme.palette.mainAppColor.main}`};
    width: 25vmin;
    height: 22vmin;
    border-radius: 10px;
    border: none;
    margin: 2vmin;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      height: 10vmin;
      width: 10vmin;
    }

    p {
      font-size: 2vmin;
    }
  }

  .black-overlay {
    position: absolute;
    top: 0;
    bottom: 75vh;
    right: 0;
    left: 0;

    background: linear-gradient(180deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.4) 40%, rgba(255,255,255,0) 100%);
  }

  *:not(.black-overlay) {
    z-index: 2;
  }
`;
const defaultError = i18n_js_1.default.t('guest_journey_an_error_has_occured_kiosk');
const KioskModeHome = (props) => {
    const { hotelView, history, baseUrl, location, updateStore, currentLocale } = props;
    const [homepageData, setHomepageData] = (0, react_1.useState)(null);
    const [pageDataLoaded, setPageDataLoaded] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)('');
    const [showInternetDialogError, setShowInternetDialogError] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        updateStore('kioskModeEnabled', true);
        const kioskToken = localStorage.getItem('kioskUserToken');
        const localStorageSessionToken = localStorage.getItem('stationToken');
        const urlStationToken = query_string_1.default.parse(location.search).station_token;
        const stationToken = urlStationToken || localStorageSessionToken;
        localStorage.setItem('stationToken', stationToken);
        const stationTokenQueryParam = stationToken ? `&station_token=${stationToken}` : '';
        if (kioskToken) {
            apiService_1.default
                .getKioskStartPage(currentLocale, kioskToken, stationTokenQueryParam)
                .then((data) => {
                if (data.status === 'success') {
                    updateStore('posTerminalEnabled', data.startPage.posTerminalEnabled);
                    setHomepageData(data.startPage);
                    setPageDataLoaded(true);
                }
                else {
                    setError(defaultError);
                }
            })
                .catch(() => {
                setError(defaultError);
            });
        }
    }, []);
    const startFlow = (tileType) => {
        let internetConnectionError = false;
        if (!navigator.onLine) {
            internetConnectionError = true;
            setShowInternetDialogError(internetConnectionError);
            return;
        }
        // checkin
        if (tileType === 'kiosk_guest_journey_checkin') {
            history.push({
                pathname: `${baseUrl}/guest_journey`,
                search: location.search,
            });
        }
        // checkout
        if (tileType === 'kiosk_guest_journey_checkout') {
            history.push({
                pathname: `${baseUrl}/guest_journey`,
                search: location.search,
                state: { inKioskModeCheckout: true },
            });
        }
        // key cards
        if (tileType === 'kiosk_guest_journey_key_card') {
            history.push({
                pathname: `${baseUrl}/guest_journey/kiosk/keycard_activation`,
                search: location.search,
                state: { inKeycardActivation: true },
            });
        }
    };
    return (react_1.default.createElement(KioskWrapper, { hotelView: hotelView },
        pageDataLoaded && (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(Logo_1.default, { className: "logo" }),
            react_1.default.createElement(LanguageDropdown_1.default, null),
            react_1.default.createElement("div", { className: "content" },
                react_1.default.createElement("h1", null, homepageData.texts && homepageData.texts.headline ? homepageData.texts.headline : ''),
                react_1.default.createElement("h3", null, homepageData.texts && homepageData.texts.caption ? homepageData.texts.caption : ''),
                react_1.default.createElement("div", { className: "tiles" }, homepageData.tiles ? buildTiles(homepageData.tiles, startFlow) : '')))),
        !pageDataLoaded && !error && react_1.default.createElement(Loader_1.default, null),
        react_1.default.createElement("div", { className: "black-overlay" }),
        react_1.default.createElement(material_1.Dialog, { "data-testid": "token-errors", open: !!error, "aria-describedby": "alert-dialog-slide-description" },
            react_1.default.createElement(material_1.DialogContent, null, error),
            react_1.default.createElement(material_1.DialogActions, { sx: {
                    justifyContent: 'center',
                } },
                react_1.default.createElement(material_1.Button, { onClick: () => {
                        window.location.reload();
                    } },
                    ' ',
                    i18n_js_1.default.t('kiosk_refresh')))),
        react_1.default.createElement(material_1.Dialog, { "data-testid": "internet-error", open: showInternetDialogError, keepMounted: true, onClose: () => { }, "aria-describedby": "alert-internet-connection-off " },
            react_1.default.createElement(material_1.DialogTitle, null,
                " ",
                i18n_js_1.default.t('key_cards_internet_error'),
                " "),
            react_1.default.createElement(material_1.DialogContent, null,
                " ",
                i18n_js_1.default.t('guest_journey_internet_dialog_content'),
                " "),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => setShowInternetDialogError(false) },
                    " ",
                    i18n_js_1.default.t('ok'),
                    " ")))));
};
function buildTiles(tiles, startFlow) {
    return tiles.map((tile) => (react_1.default.createElement("button", { className: "checkin tile", onClick: () => {
            startFlow(tile.type);
        }, key: tile.id + tile.type },
        react_1.default.createElement("img", { src: tile.icon, alt: "logo" }),
        react_1.default.createElement("p", { className: "tile-title" }, tile.title))));
}
const mapStoreToProps = (store) => ({
    hotelView: store.getValue('hotelView'),
    baseUrl: store.getValue('baseUrl'),
    currentLocale: store.getValue('currentLocale'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(KioskModeHome));
